import { CreditPurchaseConfirmBlockProps, CreditPurchaseConfirmBlockStateProps } from '../../types/components/shared/CreditPurchaseConfirmBlock';
import { User } from '../../types/api/UsersTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { connect } from 'react-redux';

import { USER_TEAM_ROLE_NAMES } from '../../constants/api';

const CreditPurchaseConfirmBlock: React.FC<CreditPurchaseConfirmBlockProps> = ({
  user,
  showConfirmBlock,
  purchasedItem,
  onConfirm,
  className,
}) => {
  if (!showConfirmBlock) return null;

  const getCreditPriceText = (): string => {
    const credits = purchasedItem.credit_price;
    return `${credits} ${credits === 1 ? 'credit' : 'credits'}`;
  }

  if (user?.team?.role_name === USER_TEAM_ROLE_NAMES.DOWNLOAD_ONLY) {
    return (
      <div
        cy-test-id="cannot-confirm-block"
        className="max-md:w-[calc(100vw-32px)] mt-3 p-4 rounded-[5px] border-solid border-[1px] z-30 border-grey-70 bg-gray-800 text-white min-w-[328px]"
      >
        <p className="font-normal text-16 leading-24 inter" cy-test-id="confirm-message">
          <strong>Permission Error:</strong><br />
          Your account role does not have sufficient permissions to buy new products.
        </p>
      </div>
    );
  };

  return (
    <div
      cy-test-id="confirm-block"
      className={`max-md:w-[calc(100vw-32px)] mx-4 md:mx-0 p-4 rounded-[5px] border-solid border-[1px] z-30 border-grey-70 bg-gray-800 text-white md:min-w-[328px] ${className ? className : ''}`}
    >
      <p className="font-normal text-16 leading-24 inter" cy-test-id="confirm-message">
        By confirming, <span className="font-bold">{getCreditPriceText()}</span>{' '}
        will be deducted from your account balance.
      </p>
      <button
        className="py-3 px-6 bg-a-blue uppercase justify-center items-center text-white rounded-[5px] eurostile text-17 leading-24 font-bold w-full mt-4"
        cy-test-id="confirm-purchase-button"
        onClick={onConfirm}>
        confirm purchase
      </button>
    </div>
  );
};

const mapStateToProps = (state: ApplicationState): CreditPurchaseConfirmBlockStateProps => ({
  user: state.auth.user as User,
});

export default connect(mapStateToProps)(CreditPurchaseConfirmBlock);
